import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const carouselImages = [
  "https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/post%2FBSF_Houston.png?alt=media&token=35654264-58e5-4bec-8719-ed8dc5d806f5",
  "https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/post%2FBSF_LongBeach%20-%202.png?alt=media&token=79c7d69b-72d9-4438-922f-10f36a9b8498",
  "https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/post%2FBSF_LongBeach%20-%203.png?alt=media&token=f151a795-33b5-43c2-906d-75aab555ad7f",
  "https://firebasestorage.googleapis.com/v0/b/jwoomycorn-4a5ca.firebasestorage.app/o/post%2FBSF_LongBeach%20-%204.png?alt=media&token=82d3008d-67c2-4fd0-9aaf-d0f74dc66d41"
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 900,
  autoplay: true,
  autoplaySpeed: 6000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

const Carousel = () => {
  return (
    <div className="hero-carousel">
      <Slider {...sliderSettings}>
        {carouselImages.map((url, i) => (
          <div key={i}>
            <img src={url} alt={`carousel-${i + 1}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
